'use strict';

function dateIsValid(d) {
  return !isNaN(d.getTime());
}

module.exports = dateIsValid;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/dateIsValid.js
// module id = 236
// module chunks = 0